import { Action } from 'redux';
import { ContractAccessState, ContractAccessUnloadState } from '../../states/ContractAccess.State';

export default function ContractAccessStatusReducer(
  state: ContractAccessState | undefined,
  action: Action
): ContractAccessState {
  const currentState = state ?? ContractAccessUnloadState;
  const a: any = action;

  switch (a.type) {

    // GET ALL
    case 'CONTRACT_ACCESS_GETALL_REQUEST':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_GETALL_SUCCESS':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_GETALL_FAILURE':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'CONTRACT_ACCESS_GETBYID_REQUEST':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: undefined,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_GETBYID_SUCCESS':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_GETBYID_FAILURE':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // CREATE
    case 'CONTRACT_ACCESS_CREATE_REQUEST':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_CREATE_SUCCESS':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_CREATE_FAILURE':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error
      };

    // UPDATE
    case 'CONTRACT_ACCESS_UPDATE_REQUEST':
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: undefined,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_UPDATE_SUCCESS':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_UPDATE_FAILURE':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error
      };

    // DELETE
    case 'CONTRACT_ACCESS_DELETE_REQUEST':
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_DELETE_SUCCESS':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'CONTRACT_ACCESS_DELETE_FAILURE':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
